import { Card } from '@/scopes/common/components/Card'
import { Skeleton } from '@sunwebgroup/ui-components/uds'
import styles from './AccoCardLoading.module.css'

export function AccoCardLoading() {
  return (
    <Card className={styles.cardSkeleton}>
      <Skeleton className={styles.imageSkeleton} />
      <div className={styles.body}>
        <Skeleton className={styles.textSkeleton} style={{ width: '90px' }} />
        <Skeleton className={styles.textSkeleton} style={{ width: '100%' }} />
        <Skeleton className={styles.textSkeleton} style={{ width: '100%' }} />
        <Skeleton className={styles.textSkeleton} style={{ width: '60%' }} />
      </div>
      <div className={styles.footer}>
        <div className={styles.leftWrapper}>
          <Skeleton className={styles.textSkeleton} style={{ width: '60%' }} />
        </div>
        <div className={styles.rightWrapper}>
          <Skeleton className={styles.textSkeleton} style={{ width: '60%' }} />
        </div>
      </div>
      <Skeleton className={styles.buttonSkeleton} />
    </Card>
  )
}
